import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFAmazon, EFJD, EFRakuten, EFShopify } from '@/components/UI/svg/river2';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

const IconAct = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="262" height="46" viewBox="0 0 262 46" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H262L255.266 30.3344C253.234 39.4872 245.117 46 235.741 46H24.4046C14.5762 46 6.20435 38.8588 4.65473 29.1533L0 0Z"
            fill="url(#paint0_linear_1_5019)"
        />
        <defs>
            <linearGradient id="paint0_linear_1_5019" x1="-128.951" y1="-5.03948" x2="-128.219" y2="62.1608" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FD9DF3" />
                <stop offset="1" stopColor="#6134FD" />
            </linearGradient>
        </defs>
    </svg>
);

export enum BuyBtnType {
    Amazon,
    Soon,
    Lotte,
    Shopify,
    Rakuten,
    JD,
    Notify,
}

const { EFPic } = createEFPic('/media/river2/pc/');
const { EFPic: EFPic2 } = createEFPic('');

// 第三个时间段
export const buyLinkMap3: any = {
    cn: {
        river2: {
            [BuyBtnType.JD]: 'https://item.jd.com/10023368540908.html',
        },
        river2_max: {
            [BuyBtnType.JD]: 'https://item.jd.com/10023352057072.html',
        },
        river2_pro: {
            [BuyBtnType.JD]: 'https://item.jd.com/10083999331675.html',
        },
    },
    us: {
        river2: {
            [BuyBtnType.Shopify]: `https://us.ecoflow.com/products/river-2-240-portable-power-station?variant=40957077487689`,
        },
        river2_max: {
            [BuyBtnType.Shopify]: `https://us.ecoflow.com/products/river-2-max-500-portable-power-station?variant=40956039004233`,
        },
        river2_pro: {
            [BuyBtnType.Shopify]: `https://us.ecoflow.com/products/river-2-pro-700-portable-power-station?variant=40957080797257`,
        },
    },
    za: {
        river2: {
            [BuyBtnType.Shopify]: 'https://za.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://za.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Soon]: '',
        },
    },
    au: {
        river2: {
            [BuyBtnType.Shopify]: 'https://au.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://au.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    ca: {
        river2: {
            [BuyBtnType.Shopify]: 'https://ca.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://ca.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    eu: {
        river2: {
            [BuyBtnType.Shopify]: 'https://eu.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://eu.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://eu.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    uk: {
        river2: {
            [BuyBtnType.Shopify]: 'https://uk.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://uk.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://uk.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    de: {
        river2: {
            [BuyBtnType.Shopify]: 'https://de.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://de.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://de.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    fr: {
        river2: {
            [BuyBtnType.Shopify]: 'https://fr.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://fr.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://fr.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    it: {
        river2: {
            [BuyBtnType.Shopify]: 'https://it.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://it.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://it.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    es: {
        river2: {
            [BuyBtnType.Shopify]: 'https://es.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://es.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://es.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    jp: {
        river2: {
            [BuyBtnType.Shopify]: 'https://jp.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://jp.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://jp.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    cis: {
        river2: {
            [BuyBtnType.Shopify]: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-max',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-pro',
        },
    },
    sa: {
        river2: {
            [BuyBtnType.Shopify]: 'https://sa.ecoflow.com/products/river-2-portable-power-station',
            [BuyBtnType.Amazon]: 'https://www.amazon.ae/dp/B0BFQC1CNQ?ref=myi_title_dp',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://sa.ecoflow.com/products/river-2-max-portable-power-station',
            [BuyBtnType.Amazon]: 'https://www.amazon.ae/dp/B0BFQB86ZL?ref=myi_title_dp',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://sa.ecoflow.com/products/river-2-pro-portable-power-station',
            [BuyBtnType.Amazon]: 'https://www.amazon.ae/EF-ECOFLOW-Portable-Charging-Generator/dp/B0CC5PKRFQ',
        },
    },
    tw: {
        river2: {
            [BuyBtnType.Soon]: '',
        },
        river2_max: {
            [BuyBtnType.Soon]: '',
        },
        river2_pro: {
            [BuyBtnType.Soon]: '',
        },
    },
    kr: {
        river2: {
            [BuyBtnType.Shopify]: 'https://kr.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://kr.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://kr.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
    br: {
        river2: {
            [BuyBtnType.Shopify]: `https://br.ecoflow.com/products/river-2-portable-power-station`,
        },
        river2_max: {
            [BuyBtnType.Shopify]: `https://br.ecoflow.com/products/river-2-max-portable-power-station`,
        },
        river2_pro: {
            [BuyBtnType.Shopify]: `https://br.ecoflow.com/products/river-2-pro-portable-power-station`,
        },
    },
    mx: {
        river2: {
            [BuyBtnType.Shopify]: `https://mx.ecoflow.com/products/river-2-portable-power-station`,
        },
        river2_max: {
            [BuyBtnType.Shopify]: `https://mx.ecoflow.com/products/river-2-max-portable-power-station`,
        },
        river2_pro: {
            [BuyBtnType.Shopify]: `https://mx.ecoflow.com/products/river-2-pro-portable-power-station`,
        },
    },
    ph: {
        river2: {
            [BuyBtnType.Shopify]: 'https://ph.ecoflow.com/products/river-2-portable-power-station',
        },
        river2_max: {
            [BuyBtnType.Shopify]: 'https://ph.ecoflow.com/products/river-2-max-portable-power-station',
        },
        river2_pro: {
            [BuyBtnType.Shopify]: 'https://ph.ecoflow.com/products/river-2-pro-portable-power-station',
        },
    },
};

export default function D({ IS_ZA_SALE, IS_ZA_END }: any) {
    const { useEffect, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'jp', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'za', 'au', 'ph']);
    const buyLinkLocale = buyLinkMap3[locale] || buyLinkMap3.us;
    if (locale === 'za' && IS_ZA_SALE) {
        buyLinkLocale.river2_pro = {
            [BuyBtnType.Shopify]: 'https://za.ecoflow.com/products/river-2-pro-portable-power-station',
        };
    }

    useEffect(() => {
        const controller = new ScrollMagic.Controller();

        // 文字--进入
        const sceneD1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_D .text-wrapper-head-in',
            triggerHook: 1,
            offset: 0,
            duration: '70%',
        });
        const tweenD1 = TweenMax.to('.river2_detials_D .text-wrapper-head .title', 0.5, {
            scale: 1,
            y: 0,
            opacity: 1,
            ease: 'none',
        });
        sceneD1.setTween(tweenD1);

        controller.addScene(sceneD1);

        // 彩色背景位移--进入
        const sceneB1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_D',
            triggerHook: 0,
            offset: 0,
            duration: 200,
        });
        const tweenB1 = TweenMax.to('.river2_detials_D .img-wrapper', 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneB1.setTween(tweenB1);

        controller.addScene(sceneB1);

        // 彩色背景位移--离开
        const sceneB2 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_E .img-wrapper',
            triggerHook: 1,
            offset: 0,
            duration: 200,
        });
        const tweenB2 = TweenMax.to('.river2_detials_D .img-wrapper', 0.5, {
            opacity: 0,
            ease: 'none',
        });
        sceneB2.setTween(tweenB2);

        controller.addScene(sceneB2);
    }, []);

    const onLink = (link: string, type: string, btnName: string, pName: string, signup = false) => {
        if (signup) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        try {
            // fb埋点
            if (type === 'amazon') {
                window?.fbq('track', 'AddToWishlist');
            }
            if (type === 'rakuten') {
                window?.fbq('track', 'donate');
            }
            if (type === 'store') {
                window?.fbq('track', 'Search');
            }
            if (type === 'notify') {
                window?.fbq('track', 'Contact');
            }
            saveAICookieForShopify(link, locale);

            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: `buy_on_${['store', 'amazon', 'notify'].includes(type) ? (type === 'notify' ? 'store' : type) : 'other'}`,
                product_name: pName,
                button_name: btnName,
                list_name: 'Middle Product List',
            });
        } catch (e) {
            console.log(e);
        } finally {
            saveCookieForShopify(link, locale);
            window?.open(link, '_blank');
        }
    };

    return (
        <div className={`${css.D_4} river2_detials_D`}>
            <div className="sticky-wrapper">
                <div className="img-wrapper">
                    <EFPic name={['4.webp', '4.jpg']} className="fullImgs" alt={t('river2.details.sec3_title')} aria-label={t('river2.details.sec3_title')} />
                </div>
            </div>
            <div className="text-wrapper-head">
                <div className="text-wrapper-head-in">
                    <div className="title">{t('river2.details.sec3_title')}</div>
                </div>
            </div>
            <div className="text-wrapper">
                <div className="product-list">
                    <div className="product-wrapper product-river2-pro">
                        {['za'].includes(locale) && !IS_ZA_END && (
                            <div className="icon-act">
                                <IconAct />
                                <p>Double EcoCredits April 15–29 Only</p>
                            </div>
                        )}
                        <div className="name">{t('river2.details.sec4_river2_pro')}</div>
                        <div className="desc">{t('river2.details.sec4_river2_pro_desc')}</div>
                        <div className="img">
                            {locale === 'ph' ? (
                                <EFPic2
                                    name="https://websiteoss.ecoflow.com/upload/image/1751249919958/1.jpg"
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2_pro')}
                                    aria-label={t('river2.details.sec4_river2_pro')}
                                />
                            ) : (
                                <EFPic
                                    name={[
                                        `D_river2_pro_${locale === 'jp' ? 'en' : imgSpec}.webp`,
                                        `D_river2_pro_${locale === 'jp' ? 'en' : imgSpec}.${locale === 'au' ? 'png' : 'jpg'}`,
                                    ]}
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2_pro')}
                                    aria-label={t('river2.details.sec4_river2_pro')}
                                />
                            )}
                        </div>
                        <div className="btn-wrapper">
                            <div className="btns">
                                {BuyBtnType.Notify in buyLinkLocale.river2_pro && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() =>
                                                onLink(
                                                    buyLinkLocale.river2_pro[BuyBtnType.Notify],
                                                    'notify',
                                                    'Notify Me',
                                                    'RIVER 2 Pro',
                                                    buyLinkLocale.river2_pro?.signup,
                                                )
                                            }
                                        >
                                            <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Shopify in buyLinkLocale.river2_pro && (
                                    <div className="btn-shopify buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.Shopify], 'store', 'Buy on Ecoflow Store', 'RIVER 2 Pro')}
                                        >
                                            {!['cis'].includes(locale) && (
                                                <div className="icon icon-shopify">
                                                    <EFShopify />
                                                </div>
                                            )}
                                            <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Amazon in buyLinkLocale.river2_pro && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2 Pro')}
                                        >
                                            <div className="icon">
                                                <EFAmazon />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Rakuten in buyLinkLocale.river2_pro && (
                                    <div className="btn-rakuten buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2 Pro')}
                                        >
                                            <div className="icon icon-rakuten">
                                                <EFRakuten />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Lotte in buyLinkLocale.river2_pro && (
                                    <div className="btn-lotte buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2 Pro')}
                                        >
                                            <div className="icon"></div>
                                            <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.JD in buyLinkLocale.river2_pro && (
                                    <div className="btn-jd buy-btn">
                                        <div className="link" onClick={() => onLink(buyLinkLocale.river2_pro[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2 Pro')}>
                                            <div className="icon">
                                                <EFJD />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Soon in buyLinkLocale.river2_pro && (
                                    <div className="btn-soon buy-btn">
                                        <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <p className="price">R11,999</p>
                    </div>
                    <div className="product-wrapper product-river2-max">
                        <div className="name">{t('river2.details.sec4_river2_max')}</div>
                        <div className="desc">{t('river2.details.sec4_river2_max_desc')}</div>
                        <div className="img">
                            {locale === 'ph' ? (
                                <EFPic2
                                    name="https://websiteoss.ecoflow.com/upload/image/1751249920136/2.jpg"
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2_max')}
                                    aria-label={t('river2.details.sec4_river2_max')}
                                />
                            ) : (
                                <EFPic
                                    name={[
                                        `D_river2_max_${locale === 'jp' ? 'en' : imgSpec}.webp`,
                                        `D_river2_max_${locale === 'jp' ? 'en' : imgSpec}.${locale === 'au' ? 'png' : 'jpg'}`,
                                    ]}
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2_max')}
                                    aria-label={t('river2.details.sec4_river2_max')}
                                />
                            )}
                        </div>
                        <div className="btn-wrapper">
                            <div className="btns">
                                {BuyBtnType.Notify in buyLinkLocale.river2_max && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() =>
                                                onLink(
                                                    buyLinkLocale.river2_max[BuyBtnType.Notify],
                                                    'notify',
                                                    'Notify Me',
                                                    'RIVER 2 Max',
                                                    buyLinkLocale.river2_max?.signup,
                                                )
                                            }
                                        >
                                            <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Shopify in buyLinkLocale.river2_max && (
                                    <div className="btn-shopify buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.Shopify], 'store', 'Buy on Ecoflow Store', 'RIVER 2 Max')}
                                        >
                                            {!['cis'].includes(locale) && (
                                                <div className="icon">
                                                    <EFShopify />
                                                </div>
                                            )}
                                            <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Amazon in buyLinkLocale.river2_max && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2 Max')}
                                        >
                                            <div className="icon">
                                                <EFAmazon />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Rakuten in buyLinkLocale.river2_max && (
                                    <div className="btn-rakuten buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2 Max')}
                                        >
                                            <div className="icon icon-rakuten">
                                                <EFRakuten />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Lotte in buyLinkLocale.river2_max && (
                                    <div className="btn-lotte buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2 Max')}
                                        >
                                            <div className="icon"></div>
                                            <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.JD in buyLinkLocale.river2_max && (
                                    <div className="btn-jd buy-btn">
                                        <div className="link" onClick={() => onLink(buyLinkLocale.river2_max[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2 Max')}>
                                            <div className="icon">
                                                <EFJD />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Soon in buyLinkLocale.river2_max && (
                                    <div className="btn-soon buy-btn">
                                        <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <p className="price">R7,999</p>
                    </div>
                    <div className="product-wrapper product-river2">
                        <div className="name">{t('river2.details.sec4_river2')}</div>
                        <div className="desc">{t('river2.details.sec4_river2_desc')}</div>
                        <div className="img">
                            {locale === 'ph' ? (
                                <EFPic2
                                    name="https://websiteoss.ecoflow.com/upload/image/1751249920441/3.jpg"
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2')}
                                    aria-label={t('river2.details.sec4_river2')}
                                />
                            ) : (
                                <EFPic
                                    name={[
                                        `D_river2_${locale === 'jp' ? 'en' : imgSpec}.webp`,
                                        `D_river2_${locale === 'jp' ? 'en' : imgSpec}.${locale === 'au' ? 'png' : 'jpg'}`,
                                    ]}
                                    className="containImg"
                                    alt={t('river2.details.sec4_river2')}
                                    aria-label={t('river2.details.sec4_river2')}
                                />
                            )}
                        </div>
                        <div className="btn-wrapper">
                            <div className="btns">
                                {BuyBtnType.Notify in buyLinkLocale.river2 && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() =>
                                                onLink(buyLinkLocale.river2[BuyBtnType.Notify], 'notify', 'Notify Me', 'RIVER 2', buyLinkLocale.river2?.signup)
                                            }
                                        >
                                            <div className="text">{t('river2.details.sec4_btn_notify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Shopify in buyLinkLocale.river2 && (
                                    <div className="btn-shopify buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Shopify], 'store', 'Buy on EcoFlow Store', 'RIVER 2')}
                                        >
                                            {!['cis'].includes(locale) && (
                                                <div className="icon">
                                                    <EFShopify />
                                                </div>
                                            )}
                                            <div className="text">{t('river2.details.sec4_btn_shopify')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Amazon in buyLinkLocale.river2 && (
                                    <div className="btn-amazon buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Amazon], 'amazon', 'Buy on Amazon', 'RIVER 2')}
                                        >
                                            <div className="icon">
                                                <EFAmazon />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_amazon')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Rakuten in buyLinkLocale.river2 && (
                                    <div className="btn-rakuten buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Rakuten], 'rakuten', 'Buy on Rakuten', 'RIVER 2')}
                                        >
                                            <div className="icon">
                                                <EFRakuten />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_rakuten')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Lotte in buyLinkLocale.river2 && (
                                    <div className="btn-lotte buy-btn">
                                        <div
                                            className="link"
                                            onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.Lotte], 'lotte', 'Buy on Lotte', 'RIVER 2')}
                                        >
                                            <div className="icon"></div>
                                            <div className="text">{t('river2.details.sec4_btn_lotte')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.JD in buyLinkLocale.river2 && (
                                    <div className="btn-jd buy-btn">
                                        <div className="link" onClick={() => onLink(buyLinkLocale.river2[BuyBtnType.JD], 'JD', 'Buy on JD', 'RIVER 2')}>
                                            <div className="icon">
                                                <EFJD />
                                            </div>
                                            <div className="text">{t('river2.details.sec4_btn_jd')}</div>
                                        </div>
                                    </div>
                                )}
                                {BuyBtnType.Soon in buyLinkLocale.river2 && (
                                    <div className="btn-soon buy-btn">
                                        <div className="text">{t('river2.details.sec4_btn_soon')}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <p className="price">R3,999</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
